var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log",style:(_vm.dynamicStyle),attrs:{"title":_vm.infos}},[_c('span',[_vm._v(" "+_vm._s(_vm.leave.duration)+" "),_vm._v("- "+_vm._s(_vm.leave.user_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }